import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor(private backendService:BackendService) { }

 
  getMenu (){
    return this.backendService.get ("/settings/menu");
  }


  setHeaderPreference (pref){
    return this.backendService.post ("/settings/header", {banner_type: pref});
  }

  saveSettings (setting){
    return this.backendService.post ("/settings", setting);
  }

  getSettings (){
    return this.backendService.get ("/settings");
  }

  getUserTypes (){
    return this.backendService.get ("/settings/usertypes");
  }
}
